<template>
  <v-select
    :label="$t('Order.originFlgs.title')"
    v-model="model"
    :items="origin_flgs"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
  ></v-select>
</template>

<script>
import consts from "@/consts.js";

export default {
  name: "SearcherOrderOriginFlgs",

  props: ["value"],

  computed: {
    origin_flgs() {
      return consts.order.origin_flgs;
    },
  },

  data: () => ({
    model: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
